<template>
    <v-dialog v-model="dialogVisible" style="width: clamp(800px, 50%, 1000px)">
      <v-card style="overflow: hidden">
        <v-card-title style="padding-top: 16px"
          >Einloggen</v-card-title
        >
        <v-card-text style="padding-left: 16px; padding-right: 16px">
          <v-row>
              <v-col cols="12" class="pt-0">
                <v-img aspect-ratio="16/9" cover src="/images/logo.svg" />
              </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-form @submit.prevent="login">
                  <v-text-field
                      label="Benutzername"
                      v-model="username"
                      prepend-icon="mdi-account"
                      required
                  />
                  <v-text-field
                      label="Passwort"
                      v-model="password"
                      type="password"
                      prepend-icon="mdi-lock"
                      required
                  />
                  <v-btn type="submit" color="primary" class="mt-3" block>Login</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
    import { getAuthApiProxy } from '../../../plugins/axiosPlugin'
    export default {
    name: 'LoginDialog',
    data() {
        return {
          username: '',
          password: '',
          error: ''
        }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.$store.state.loginDialogVisible
        },
        set(value) {
          if (!value) this.$store.commit('closeLoginDialog')
        }
      },
    },
    methods: {
        async login() {
          const auth = getAuthApiProxy()
            try {
                const { data } = await auth.post('', {
                  username: this.username,
                  password: this.password
                })

                const token = data?.access_token
                if (!token) throw new Error('Kein Token im Login-Response')
                // Token speichern, z. B. im Store oder localStorage
                sessionStorage.setItem('access_token', token)

                // Weiterleitung
                this.closeDialog()
            } catch (err) {
                this.error = 'Login fehlgeschlagen. Bitte überprüfe deine Eingaben.'
                console.error(err)
            }
        },
        async register() {
            try {
                const response = await axios.post('/register', {
                username: this.username,
                password: this.password
                })

            } catch (err) {
                this.error = 'Login fehlgeschlagen. Bitte überprüfe deine Eingaben.'
                console.error(err)
            }
        },
        closeDialog() {
          this.dialogVisible = false
          window.location.reload();
      },
      getErrorMessage(string) {
        return string + ' darf nicht leer sein'
      }
    }
    }
</script>  